// extracted by mini-css-extract-plugin
export default {"container":"InputGroupPergunta_container__rbUl2","containerChildren":"InputGroupPergunta_containerChildren__U8oxS"};